<template>
  <div>
    <div class="card" v-if="completed">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-header-title" v-if="course">
              {{ course.name }}
            </h5>
            <a :href="backLink" class="text-muted">Retour à liste des parcours</a>
        </div>
        <div class="card-body text-center">
            <blockquote class="blockquote text-center mb-4">
              <p class="mb-0">Vous avez terminé le parcours.</p>
              <footer class="blockquote-footer">{{ course.name }}</footer>
            </blockquote>

            <img :src="completedPicture" class="img-fluid mb-4" alt="Completed" style="width: 400px; " />
        </div>
    </div>
    <div class="row" v-else>
        <div class="col-sm-12" v-if="video">
            <quizz-component :has-questions="hasQuestions" :admin="admin" :video="video" :questions-completed="questionsCompleted" :video-id="video.id" @nextvideo="handleNextVideo()"></quizz-component>
        </div>
    </div>
  </div>
</template>

<script>
import QuizzComponent from './NewQuizzComponent.vue'

export default {
  components: {
    QuizzComponent
  },

  props: {
    courseId: Number,
    backLink: String,
    completedPicture: String,
    admin: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      course: null,
      video: null,
      videos: null,
      questionsCompleted: null,
      nextVideo: null,
      completed: false,
      hasQuestions: false,
    }
  },

  methods: {
    handleNextVideo() {
      this.getVideo()
    },

    getVideo() {
      axios.get(`/webapi/courses/${this.courseId}/video`)
        .then((res) => {
          this.course = res.data.course
          this.video = res.data.video
          this.nextVideo = res.data.next_video
          this.videos = res.data.videos
          this.completed = res.data.completed
          this.questionsCompleted = res.data.questions_completed

          if (res.data.video) {
            this.hasQuestions = res.data.video.questions.length > 0
          }
        })
        .catch((err) => console.log(err))
    }
  },

  created() {
    this.getVideo()
  }
}
</script>
